import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Row, Col } from 'reactstrap';
import { Link } from "react-router-dom";
import { PageTitle } from '../../components';
import { Utils } from '../../services';
import { Revenue, TodayScreenings, UserPlanning } from './Widgets';

import './Dashboard.css';

const Dashboard = () => {
    const { t } = useTranslation();

    const me = useSelector(state => state.auth.user);

    if (!me || !me.tkt_instance)
        return null;

    return (
        <div className="Dashboard">
            <PageTitle icon="rocket" title={ t("app.section_operation") } />
            <Row>
                {me.tkt_instance.hasModule(Utils.MODULE_PLANNING) && me.can('read', 'screenings') && (
                    <Col sm={12} lg={6} className="mb-3">
                        <TodayScreenings />
                    </Col>
                )}
                {me.can('read', 'stats') && (
                    <Col sm={12} lg={6} className="mb-3">
                        <Revenue />
                    </Col>
                )}
                {me.tkt_instance.hasModule(Utils.MODULE_RESOURCES) && me.can('read', 'tasks') && (
                    <Col sm={12} lg={6} className="mb-3">
                        <UserPlanning />
                    </Col>
                )}
            </Row>
        </div>
    );
}

export default Dashboard;
